import React from 'react';
import ManageEmployeesTabs from './ManageEmployeesTabs';

const ManageEmployees = () => {
  return <ManageEmployeesTabs />;
};

export default ManageEmployees;
